import { render, staticRenderFns } from "./ReferralsCounterComponent.vue?vue&type=template&id=370cc08c&scoped=true"
import script from "./ReferralsCounterComponent.vue?vue&type=script&lang=js"
export * from "./ReferralsCounterComponent.vue?vue&type=script&lang=js"
import style0 from "./ReferralsCounterComponent.vue?vue&type=style&index=0&id=370cc08c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370cc08c",
  null
  
)

export default component.exports